import { SocialMediaResizeTool } from '@/features/social-media-resize'

export function SocialMediaResizePage() {
  return <SocialMediaResizeTool />
}
